import Timetable from './Timetable';

function App() {
  return (
    <div className="App">
     <Timetable /> 
      </div>
       

     
  );
}

export default App;
